const TITLE = 'title';
const HTML_TITLE = 'html_title';

type TitleKey = typeof TITLE | typeof HTML_TITLE;
type TranslatedKey = `${TitleKey}_translated`;

type Item = {
  title?: string|null|undefined;
  html_title?: string|null|undefined;
  title_translated?: string|null|undefined;
  html_title_translated?: string|null|undefined;
};

const getTitleByKey = <K extends TitleKey>(item: Item, isTranslationAllowed: boolean, key: K = TITLE as K) => {
  const keyTrans = `${key}_translated` as TranslatedKey;

  return isTranslationAllowed && item[keyTrans] ? item[keyTrans] : item[key];
};

export const getTitle = (item: Item, isTranslationAllowed: boolean) => {
  return getTitleByKey(item, isTranslationAllowed);
};

export const getHtmlTitle = (item: Item, isTranslationAllowed: boolean) => {
  return getTitleByKey(item, isTranslationAllowed, HTML_TITLE);
};
